import { render, staticRenderFns } from "./IconMenu.vue?vue&type=template&id=95072b06&scoped=true"
import script from "./IconMenu.vue?vue&type=script&lang=js"
export * from "./IconMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95072b06",
  null
  
)

export default component.exports